/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ModeratorConversation,
  ModeratorConversationCreateRequest,
  ModeratorMessage,
  ModeratorMessageCreateRequest,
  ModeratorsConversationsListParams,
  ModeratorsConversationsMarkReadCreate200,
  ModeratorsConversationsMessagesRetrieveParams,
  PaginatedModeratorConversation,
  PaginatedModeratorMessage
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * List all conversations for the current moderator. Optional search on counterpart (company) name and message content. Sorted by last message. Paginated.
 * @summary List moderator conversations
 */
export const moderatorsConversationsList = (
    params?: ModeratorsConversationsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedModeratorConversation[]>(
      {url: `/api/v1/moderators/conversations/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsConversationsListQueryKey = (params?: ModeratorsConversationsListParams,) => {
    return [`/api/v1/moderators/conversations/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsConversationsListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsConversationsList>>, TError = unknown>(params?: ModeratorsConversationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsConversationsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsConversationsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsConversationsList>>> = ({ signal }) => moderatorsConversationsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsConversationsList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsConversationsListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsConversationsList>>>
export type ModeratorsConversationsListQueryError = unknown

/**
 * @summary List moderator conversations
 */
export const useModeratorsConversationsList = <TData = Awaited<ReturnType<typeof moderatorsConversationsList>>, TError = unknown>(
 params?: ModeratorsConversationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsConversationsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsConversationsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Moderator-company conversation management
 * @summary Get moderator conversation detail
 */
export const moderatorsConversationsDetailRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ModeratorConversation>(
      {url: `/api/v1/moderators/conversations/${id}/detail/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsConversationsDetailRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/moderators/conversations/${id}/detail/`] as const;
    }

    
export const getModeratorsConversationsDetailRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsConversationsDetailRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsConversationsDetailRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsConversationsDetailRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsConversationsDetailRetrieve>>> = ({ signal }) => moderatorsConversationsDetailRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsConversationsDetailRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsConversationsDetailRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsConversationsDetailRetrieve>>>
export type ModeratorsConversationsDetailRetrieveQueryError = void

/**
 * @summary Get moderator conversation detail
 */
export const useModeratorsConversationsDetailRetrieve = <TData = Awaited<ReturnType<typeof moderatorsConversationsDetailRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsConversationsDetailRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsConversationsDetailRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Moderator-company conversation management
 * @summary Mark moderator conversation messages as read
 */
export const moderatorsConversationsMarkReadCreate = (
    id: number,
 ) => {
      
      
      return customInstance<ModeratorsConversationsMarkReadCreate200>(
      {url: `/api/v1/moderators/conversations/${id}/markRead/`, method: 'POST'
    },
      );
    }
  


export const getModeratorsConversationsMarkReadCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsConversationsMarkReadCreate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsConversationsMarkReadCreate>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsConversationsMarkReadCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  moderatorsConversationsMarkReadCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsConversationsMarkReadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsConversationsMarkReadCreate>>>
    
    export type ModeratorsConversationsMarkReadCreateMutationError = void

    /**
 * @summary Mark moderator conversation messages as read
 */
export const useModeratorsConversationsMarkReadCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsConversationsMarkReadCreate>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsConversationsMarkReadCreate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getModeratorsConversationsMarkReadCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Moderator-company conversation management
 * @summary List messages in moderator conversation
 */
export const moderatorsConversationsMessagesRetrieve = (
    id: number,
    params?: ModeratorsConversationsMessagesRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedModeratorMessage>(
      {url: `/api/v1/moderators/conversations/${id}/messages/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsConversationsMessagesRetrieveQueryKey = (id: number,
    params?: ModeratorsConversationsMessagesRetrieveParams,) => {
    return [`/api/v1/moderators/conversations/${id}/messages/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsConversationsMessagesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsConversationsMessagesRetrieve>>, TError = unknown>(id: number,
    params?: ModeratorsConversationsMessagesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsConversationsMessagesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsConversationsMessagesRetrieveQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsConversationsMessagesRetrieve>>> = ({ signal }) => moderatorsConversationsMessagesRetrieve(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsConversationsMessagesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsConversationsMessagesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsConversationsMessagesRetrieve>>>
export type ModeratorsConversationsMessagesRetrieveQueryError = unknown

/**
 * @summary List messages in moderator conversation
 */
export const useModeratorsConversationsMessagesRetrieve = <TData = Awaited<ReturnType<typeof moderatorsConversationsMessagesRetrieve>>, TError = unknown>(
 id: number,
    params?: ModeratorsConversationsMessagesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsConversationsMessagesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsConversationsMessagesRetrieveQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Moderator-company conversation management
 * @summary Send message in moderator conversation
 */
export const moderatorsConversationsSendCreate = (
    id: number,
    moderatorMessageCreateRequest: ModeratorMessageCreateRequest,
 ) => {
      
      
      return customInstance<ModeratorMessage>(
      {url: `/api/v1/moderators/conversations/${id}/send/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorMessageCreateRequest
    },
      );
    }
  


export const getModeratorsConversationsSendCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsConversationsSendCreate>>, TError,{id: number;data: ModeratorMessageCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsConversationsSendCreate>>, TError,{id: number;data: ModeratorMessageCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsConversationsSendCreate>>, {id: number;data: ModeratorMessageCreateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsConversationsSendCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsConversationsSendCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsConversationsSendCreate>>>
    export type ModeratorsConversationsSendCreateMutationBody = ModeratorMessageCreateRequest
    export type ModeratorsConversationsSendCreateMutationError = void

    /**
 * @summary Send message in moderator conversation
 */
export const useModeratorsConversationsSendCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsConversationsSendCreate>>, TError,{id: number;data: ModeratorMessageCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsConversationsSendCreate>>,
        TError,
        {id: number;data: ModeratorMessageCreateRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsConversationsSendCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Create a conversation with a company. If one already exists, returns it (200).
 * @summary Create moderator conversation
 */
export const moderatorsConversationsCreateCreate = (
    moderatorConversationCreateRequest: ModeratorConversationCreateRequest,
 ) => {
      
      
      return customInstance<ModeratorConversation>(
      {url: `/api/v1/moderators/conversations/create/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorConversationCreateRequest
    },
      );
    }
  


export const getModeratorsConversationsCreateCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsConversationsCreateCreate>>, TError,{data: ModeratorConversationCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsConversationsCreateCreate>>, TError,{data: ModeratorConversationCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsConversationsCreateCreate>>, {data: ModeratorConversationCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsConversationsCreateCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsConversationsCreateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsConversationsCreateCreate>>>
    export type ModeratorsConversationsCreateCreateMutationBody = ModeratorConversationCreateRequest
    export type ModeratorsConversationsCreateCreateMutationError = void

    /**
 * @summary Create moderator conversation
 */
export const useModeratorsConversationsCreateCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsConversationsCreateCreate>>, TError,{data: ModeratorConversationCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsConversationsCreateCreate>>,
        TError,
        {data: ModeratorConversationCreateRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsConversationsCreateCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    